import * as Yup from 'yup';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
// mui
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import Card from '@mui/material/Card';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import Slide from '@mui/material/Slide';
// hook-form
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import RHFTextFieldCustomSubMenu from 'src/components/hook-form/rhf-text-field-custom-subMenu';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
// context
import { ModificationContext, typeIDContext } from 'src/context/Context';
import { handleApiAction } from 'src/utils/handleApiAction';
// api
import { fetchTraineeData, saveTraineeData } from 'src/components/userSetting/api/services';


const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const defaultStatut = [
  { value: 'Employé', label: 'Employé' },
  { value: 'Indépendant', label: 'Indépendant' },
  { value: 'Particulier', label: 'Particulier' },
];

const STATUTS = ['Employé', 'Indépendant', 'Particulier'];
const PHONE_FR_REGEX = /^(?:\+33|0)\s?[1-9](?:[\s.\-]?\d{2}){4}$/; // 0X XX XX XX XX ou +33 X XX XX XX XX
const ZIP_FR_REGEX = /^\d{5}$/;               // 5 chiffres
const SIRET_REGEX = /^\d{14}$/;               // 14 chiffres
const TVA_FR_REGEX = /^FR[0-9A-Z]{2}\d{9}$/;  // FR + 2 clé alphanum + 9 chiffres (SIREN)

const UserInfoSchema = Yup.object().shape({
  first_name: Yup.string().trim().required('Le prénom est requis'),
  name: Yup.string().trim().required('Le nom de famille est requis'),
  email: Yup.string().trim().email('Email invalide').required("L'email est requis"),

  address: Yup.string().trim().required("L'adresse est requise"),
  country: Yup.string().trim().required('Le pays est requis'),
  town: Yup.string().trim().required('La ville est requise'),

  statut: Yup.string().oneOf(STATUTS, 'Statut invalide').required('Le statut est requis'),

  zip_code: Yup.string()
    .trim()
    .matches(ZIP_FR_REGEX, 'Code postal invalide')
    .required('Le code postal est requis'),

  phone: Yup.string()
    .trim()
    .matches(PHONE_FR_REGEX, 'Numéro de téléphone invalide (FR attendu)')
    .required('Le numéro de téléphone est requis'),

  // on garde TES noms de champs actuels :
  compagny: Yup.string()
    .trim()
    .when('statut', {
      is: (s) => s !== 'Particulier',
      then: (schema) => schema.required("Le nom de l'entreprise est requis"),
      otherwise: (schema) => schema.notRequired(),
    }),

  job: Yup.string()
    .trim()
    .when('statut', {
      is: (s) => s !== 'Particulier',
      then: (schema) => schema.required('Le poste est requis'),
      otherwise: (schema) => schema.notRequired(),
    }),

  siret: Yup.string()
    .trim()
    .when('statut', {
      is: 'Indépendant',
      then: (schema) =>
        schema
          .required('Le numéro de SIRET est requis pour un indépendant')
          .matches(SIRET_REGEX, 'Numéro de SIRET invalide (14 chiffres)'),
      otherwise: (schema) =>
        schema
          .notRequired()
          .test(
            'siret-format-if-present',
            'Numéro de SIRET invalide (14 chiffres)',
            (val) => !val || SIRET_REGEX.test(val)
          ),
    }),
});

const ModalAcivateAccount = ({ user, width = 'md' }) => {

  const formUrl = useContext(typeIDContext);
  const modal = useContext(ModificationContext);
  const navigate = useNavigate();

  const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [allert, setAllert] = useState('succes');

  const defaultValues = {
    first_name: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    country: '',
    zip_code: '',
    town: '',
    statut: '',
    compagny: '',
    job: '',
    vatnumber: '',
    siret: '',
  };

  const methods = useForm({
    resolver: yupResolver(UserInfoSchema),
    defaultValues,
    mode: 'onSubmit', // explicite
  });

  const {
    reset,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  const handleSaveTraineeData = (data, userID) =>
  {      
    const payload = { ...data, userID };

    handleApiAction({
        action: saveTraineeData,
        payload,
        onSuccess: () => { 
          modal.updateModification(false); 
          
          const rawParams = localStorage.getItem('params');
          const params = rawParams ? JSON.parse(rawParams) : null;
          
          if(formUrl.typeID && user.id===params.traineeID){
            navigate( formUrl.typeID );
            formUrl.updateTypeID(null);
            localStorage.removeItem('params');
          }else{
            navigate( '/organization/trainees/profile', { 
              state: { traineeID: user?.id, role:"trainee", loadFrom: "/", role:"trainee"  }
            });

            formUrl.updateTypeID(null);
            localStorage.removeItem('params');
          }

        },
        enqueueSnackbar,
        logout,
    });
  }

  const submitHandler = async (data) => {
    handleSaveTraineeData(data, user.id);
  };

  const onSubmit = handleSubmit(submitHandler);

  const handleClose = () => {
    modal.updateModification(false);
  };
  
  const handleFetchUserData= (userID) =>{
    
      const opt = {
        onAuthRequired: async () => {
          enqueueSnackbar('Session expirée. Veuillez vous reconnecter.', { variant: 'warning' });
          await logout();
        },
      };
  
      fetchTraineeData(userID, opt)
      .then((response)=>{ 
        reset({
          ...defaultValues,
          ...response.data,
        });
      })
      .catch((err)=>{ console.error(err); })
  }

  // Nettoie l'erreur quand on modifie le form
  useEffect(() => {
    if (error) setError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    if (modal.modification && user?.id) handleFetchUserData(user.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.modification, user?.id]);

  useEffect(() => {
      const params = JSON.parse(localStorage.getItem('params'));

      if (params !== null) {
        formUrl.updateTypeID(`/forms/${params?.id}/filled/${params?.participant}`);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      open={modal.modification}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={width}
      keepMounted
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      aria-describedby="alert-dialog-slide-description"
      disableEscapeKeyDown
    >
      <DialogTitle>Validation des informations</DialogTitle>

      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogContent>
          {error && (
            <Alert severity={allert} sx={{ mb: 3 }}>
              {message}
            </Alert>
          )}

          <Card>
            <Grid container spacing={3} sx={{ px: 3, pb: 5, pt: 3 }}>
              <Grid item sm={6}>
                <RHFTextField name="first_name" label="Prénom" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="name" label="Nom de Famille" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="email" label="Adresse Email" size="small" disabled/>
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="phone" label="Numéro de téléphone" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="address" label="Adresse" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="country" label="Pays" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="zip_code" label="Code postal" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="town" label="Ville" size="small" />
              </Grid>
            </Grid>
          </Card>

          <Card sx={{ mt: 3, pt: 3 }}>
            <Grid container spacing={3} sx={{ px: 3, pb: 5 }}>
              <Grid item sm={6}>
                <RHFTextFieldCustomSubMenu
                  name="statut"
                  label="Statut"
                  optionsMenu={defaultStatut}
                  size="small"
                />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="compagny" label="Entreprise" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="job" label="Poste" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="vatnumber" label="N° de TVA" size="small" />
              </Grid>

              <Grid item sm={6}>
                <RHFTextField name="siret" label="Numéro de SIRET" size="small" />
              </Grid>
            </Grid>
          </Card>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            type="submit"
            color="inherit"
            variant="contained"
            loading={isSubmitting}
            startIcon={<Iconify icon="solar:diskette-bold" />}
          >
            Enregistrer
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

ModalAcivateAccount.propTypes = {
  user: PropTypes.object.isRequired,
  width: PropTypes.string,
};

export default ModalAcivateAccount;
